// extracted by mini-css-extract-plugin
export var cardHeader = "_gf-0";
export var reorderHandle = "_gf-3";
export var titleArea = "_gf-1";
export var titleAreaWithHandle = "_gf-2";